export default __webpack_public_path__ + "static/media/60.1a749dbe.svg";